<main class="c-main" role="main">
    <div class="c-page-access">
        <div class="container u-pb30">
            <div class="row mobile u-pt40 u-pb10">
                <div class="col-md-8">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a [routerLink]="['']" style="color: black;"> {{'ThirdVisitorAccessPortal.home'|translate}} &nbsp;</a></li>
                            <li class="breadcrumb-item active" aria-current="page" style="color: black;"> - <a style="color: black;" [routerLink]="['/visitor-accesses']">{{'ThirdVisitorAccessPortal.third-verification-visitor'|translate}} &nbsp;</a></li>
                            <li class="breadcrumb-item active" aria-current="page" style="color: black;"> - <span style="color: black;">{{'ThirdVisitorAccessPortal.authorized'|translate}}</span></li>
                        </ol>
                    </nav>
                    <h2 class="o-title js-txt3">{{'ThirdVisitorAccessPortal.authorized'|translate}}</h2>
                </div>
                <div class="col-md-12" *ngIf="person">

                    <div class="col-md-4" style="padding-left: 0px">
                        <p><strong>{{'ThirdVisitorAccessPortal.name' |translate}}:&nbsp; </strong> {{person.firstName}}&nbsp; {{person.lastName}}</p>
                        <p><strong>{{titulo}}:&nbsp; </strong> {{rut}}</p>
                    </div>
                    <div class="col-md-4" style="padding-left: 0px">
                        <p><strong>{{'ThirdVisitorAccessPortal.mail-bhp'|translate}}:&nbsp; </strong> {{person.email}}</p>
                        <p *ngIf="!typePeopleContractor"><strong>{{'ThirdVisitorAccessPortal.site'|translate}}:&nbsp; </strong> {{person.companyName}}</p>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="accesses">
                <div class="col-lg-12" *ngIf="accesses.length===0">
                    <div class="u-pt20">
                        <div class="c-card c-card--success">
                            <div class="c-card__title">{{'ThirdVisitorAccessPortal.notAuthorized' | translate}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" *ngFor="let accesse of accesses">
                    <!--NGFOR-->
                    <div class="">
                        <div class="c-card c-card--success">
                            <div class="c-card__title">{{accesse.siteName | titlecase}}<span class="js-txt16"> {{'ThirdVisitorAccessPortal.titleTable' | translate}}</span></div>
                            <div class="row">
                                <div class="col-md-4">
                                    <p class="table__request"><strong class="js-txt6">{{'ThirdVisitorAccessPortal.labelRequestNumber' | translate}}: </strong> {{accesse.accessDetail.requestNumber}}</p>
                                    <!-- <p><strong class="js-txt7">{{'ThirdVisitorAccessPortal.labelRequestor' | translate}}: </strong> {{accesse.requestor}}</p> -->
                                </div>
                                <div class="col-md-4">
                                    <p> <strong class="js-txt9">{{'ThirdVisitorAccessPortal.labelZone' | translate}}: </strong> {{accesse.zoneName}} </p>
                                    <p *ngIf="accesse.subZoneName != ''"> <strong class="js-txt9">{{'ThirdVisitorAccessPortal.labelSubzone' | translate}}: </strong> {{accesse.subZoneName}} </p>
                                    <p> <strong class="js-txt9">{{'ThirdVisitorAccessPortal.qualifications' | translate}}: </strong> </p>

                                    <div *ngIf="accesse.qualification.qualificationEn != ''" class="c-card--icons-item">
                                        <i class="icon " [ngClass]="{'icon-check': accesse.qualification.status=== 1 || accesse.qualification.status=== 2, 'icon-close': accesse.qualification.status === 0 }">
                       </i>

                                        <span *ngIf="getlang()==='en'" class="js-txta1" style="text-align: left;">{{accesse.qualification.qualificationEn}}</span>
                                        <span *ngIf="getlang()==='es'" class="js-txta1" style="text-align: left;">{{accesse.qualification.qualificationEs}}</span>

                                    </div>

                                </div>
                                <div class="col-md-4">
                                    <div class="c-card__from"><i class="icon icon-calendar"></i>
                                        <p> <strong class="js-txt10">{{'ThirdVisitorAccessPortal.labelFrom' | translate}} </strong> {{accesse.accessDetail.periodFrom | date: 'dd/MM/yyyy'}}</p>
                                    </div>
                                    <div class="c-card__to"><i class="icon icon-calendar"></i>
                                        <p> <strong class="js-txt11">{{'ThirdVisitorAccessPortal.labelTo' | translate}} </strong> {{accesse.accessDetail.periodTo | date: 'dd/MM/yyyy'}}</p>
                                    </div>

                                </div>
                                <div class="col-md-12 col-xs-12">
                                    <h6 *ngIf="accesse.status===0" style="padding-top: 10px;">
                                        <hr>
                                        <p><i class="icon icon-warning" style="background-color: transparent;color: #767372;"></i> {{'ThirdVisitorAccessPortal.bring'|translate}}
                                        </p>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</main>